import o from "./ghl-ui.es1469.js";
import t from "./ghl-ui.es1294.js";
import p from "./ghl-ui.es1310.js";
var u = "['’]", a = RegExp(u, "g");
function c(r) {
  return function(e) {
    return o(p(t(e).replace(a, "")), r, "");
  };
}
export {
  c as default
};
